module.exports = __webpack_public_path__ + "static/media/service6.f1f75686.jpg";